import React, { useContext } from 'react'
import PopQuizEditor from '../../PopQuizEditor'
import { SessionContext } from '../../../../context/SessionContext'

// Final step for Pop Quiz sessions. PopQuizEditor is already a self-contained authoring
// panel driven by SessionContext + updateSessionFields, so the wizard just hosts it.
const PopQuizStep = () => {
  const { session } = useContext(SessionContext)

  return (
    <>
      <div className="cq-card__head">
        <div>
          <h2>Questions</h2>
          <p>Write the quiz questions, or generate a set with AI.</p>
        </div>
      </div>

      <div className="cq-embed">
        <PopQuizEditor key={session?.id} />
      </div>
    </>
  )
}

export default PopQuizStep
